import types from './types';
// import cartActions from './addressAction';

const initState = {
    selectedAddresses: []
};

export default function addressReducer(state = initState, action) {
    switch (action.type) {
        case types.SELECTED_ADDRESS:
            return {
                selectedAddresses: action.addressList
            };

        default:
            return state;
    }
}
